import { Row, Col, Card, Image } from 'react-bootstrap';
import PageWrapper from '../../components/PageWrapper';
import {
  FaCheckCircle,
  FaUserMd,
  FaFlask,
  FaProcedures,
  FaIdCard,
  FaNotesMedical,
  FaHeartbeat,
} from 'react-icons/fa';

const PageStructure = ({ data }) => {
  const featureIcons = [
    FaCheckCircle,
    FaUserMd,
    FaFlask,
    FaNotesMedical,
    FaHeartbeat,
  ];
  const ICON_MAP = {
    FaCheckCircle,
    FaUserMd,
    FaFlask,
    FaProcedures,
    FaNotesMedical,
    FaHeartbeat,
    FaIdCard,
  };

  return (
    // Keep PageWrapper untouched (it renders the site header/banner).
    <PageWrapper
      PageWrapper
      title={data.maintitle}
      subtitle={data.mainsubtitle}
    >
      <div className="px-4">
        {/* Render module title/subtitle inside page content (above module hero) */}
        <div className="text-center my-4">
          <h1 className="fw-bold">{data.title}</h1>
          <p className="mt-2 primary-class ">{data.subtitle}</p>
        </div>

        {/* Module hero/banner image (rendered inside content; does NOT replace PageWrapper background) */}
        {data.banner && (
          <div className="d-flex justify-content-center mb-5 px-3">
            <Image
              src={data.banner}
              className="w-100 img-fluid shadow-sm"
              style={{
                width: '100%',
                maxWidth: '1200px',
                height: 'auto',
                borderRadius: '12px',
              }}
            />
          </div>
        )}

        {/* ISSUE SECTION (Exact same as image) */}
        <Row className="align-items-center my-5">
          <Col md={6}>
            {/* Kicker */}
            {data.issueSection.kicker && (
              <div className="primary-class small fw-bold mb-2">
                {data.issueSection.kicker}
              </div>
            )}

            {/* Title + Subtitle */}
            <h2 className="fw-bold">
              {data.issueSection.title} <br />
              {data.issueSection.subtitle}
            </h2>

            {/* Features List */}
            <div className="mt-4">
              {data.issueSection.features.map((item, idx) => {
                const Icon = featureIcons[idx % featureIcons.length]; // auto-cycle icons

                return (
                  <div key={idx} className="d-flex align-items-start mb-4">
                    {/* Icon Box */}
                    <div
                      className="d-flex align-items-center justify-content-center rounded-3 me-3 "
                      style={{
                        width: '50px',
                        height: '50px',
                        backgroundColor: '#E5F3F3',
                        minWidth: '50px',
                      }}
                    >
                      <Icon size={26} color="#2A8C8C" />
                    </div>

                    {/* Texts */}
                    <div>
                      <div className="fw-bold">{item.title}</div>
                      <div className="text-muted small">{item.description}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          </Col>

          <Col md={6} className="d-flex justify-content-center">
            <Image
              src={data.issueSection.image}
              fluid
              rounded
              className="shadow-sm mx-auto d-block"
              style={{ maxWidth: '90%' }}
            />
          </Col>
        </Row>

        {data.riskSection && (
          <div className="mb-5">
            <Row className="align-items-center g-5">
              {/* LEFT IMAGE */}
              <Col lg={5} className="d-flex justify-content-center">
                <Image
                  src={data.riskSection.image}
                  fluid
                  rounded
                  loading="lazy"
                  className="shadow-sm mx-auto d-block"
                  style={{ maxWidth: '75%' }}
                />
              </Col>

              {/* RIGHT CONTENT */}
              <Col lg={6}>
                {/* TITLE */}
                <h3 className="fw-bold mb-1">{data.riskSection.title}</h3>

                {/* SUBTITLE */}
                <p className="text-muted fw-semibold mb-4">
                  {data.riskSection.subtitle}
                </p>

                {/* FEATURE LIST */}
                <div className="d-flex flex-column gap-3">
                  {data.riskSection.features.map((item, idx) => {
                    const Icon = ICON_MAP[item.icon] || FaCheckCircle;

                    return (
                      <Card key={idx} className="border-0 shadow-sm rounded-4">
                        <Card.Body className="d-flex align-items-start gap-3">
                          <div className="icon-wrapper flex-shrink-0">
                            <Icon className="primary-class fs-5" />
                          </div>

                          <div>
                            <Card.Title className="fw-bold mb-1 fs-6">
                              {item.title}
                            </Card.Title>
                            <Card.Text className="text-muted small mb-0">
                              {item.description}
                            </Card.Text>
                          </div>
                        </Card.Body>
                      </Card>
                    );
                  })}
                </div>
              </Col>
            </Row>
          </div>
        )}

        {/* 5️⃣ OPD MEDICINE SERVICE BOXES (3 equal cards with icon) */}
        <div className="text-center my-5">
          <h3 className="fw-bold mb-4">OPD Medicine & Service Advice</h3>
        </div>

        <Row className="g-4 pb-5">
          {data.opdAdvice.map((item, idx) => {
            const IconComponent =
              idx === 0 ? FaUserMd : idx === 1 ? FaFlask : FaProcedures;

            return (
              <Col md={4} key={idx}>
                <Card className="p-3 shadow-sm h-100 border-1 rounded-4">
                  {/* Icon Box */}
                  <div
                    className="d-inline-flex align-items-center justify-content-center mb-3 rounded-3"
                    style={{
                      width: '60px',
                      height: '60px',
                      backgroundColor: '#E5F3F3',
                    }}
                  >
                    <IconComponent size={28} color="#2A8C8C" />
                  </div>

                  <h6 className="fw-semibold text-start">{item.title}</h6>
                  <p className="text-muted small text-start mt-2">
                    {item.text}
                  </p>
                </Card>
              </Col>
            );
          })}
        </Row>
      </div>
    </PageWrapper>
  );
};

export default PageStructure;
